import React from 'react';

import config from "../config/config";

import AccountNavigation from './account-navigation';
import LogoutButton from '../components/logout-button';
import IFrame from '../components/iframe';

const iframeURL = `${config.DOMAIN_NAME}/${config.CLIENT_NAME}/website/secure/myaccount.aspx?screen=paymentCards&resize=true`;

const AccountPayments = () => {

    return (
        <>
            <AccountNavigation />

            <div className='booking-pathway__container booking-pathway__account booking-pathway__account--payments'>
                <div className='booking-pathway__main-content'>
                    <IFrame url={iframeURL} id="SpektrixAccountIFrame" title="Payment methods" hasLoader="true" />
                </div>

                <div className='booking-pathway__footer'>
                    <LogoutButton />
                </div>
            </div>
        </>
    );
};

export default AccountPayments;
